import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Play, Plus, CheckCircle, ListChecks, Package } from 'lucide-react';
import { 
  interventions as interventionsData,
  getTypeInterventionById,
  getCentreById,
  getPointageEnCours
} from '../../data/mockData';

function TableauDeBordTechnicien({ user }) {
  const [interventionsDuJour, setInterventionsDuJour] = useState([]);
  const [pointageActif, setPointageActif] = useState(null);
  const [interventionEnCours, setInterventionEnCours] = useState(null);

  useEffect(() => {
    // Charger les interventions du technicien pour aujourd'hui
    const today = new Date().toISOString().split('T')[0];
    const mesInterventions = interventionsData.filter(i => 
      i.technicienId === user.id && 
      i.datePrevu === today
    );
    setInterventionsDuJour(mesInterventions);

    // Vérifier si une intervention est en cours
    const enCours = mesInterventions.find(i => i.statut === 'en_cours');
    setInterventionEnCours(enCours);

    // Vérifier le pointage
    const pointage = getPointageEnCours(user.id);
    setPointageActif(pointage);
  }, [user.id]);

  const interventionsPlanifiees = interventionsDuJour.filter(i => i.statut === 'planifiee');
  const interventionsTerminees = interventionsDuJour.filter(i => i.statut === 'terminee');

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Bonjour, {user.prenom} 👋</h1>
          <p className="text-muted">Votre tableau de bord du jour</p>
        </div>
      </div>

      {/* Alerte si pas pointé */}
      {!pointageActif && (
        <div className="alert alert-warning">
          <Clock size={20} />
          <div>
            <strong>N'oubliez pas de pointer !</strong>
            <p className="text-sm" style={{ margin: '0.25rem 0 0 0' }}>
              Vous devez pointer le début de votre journée avant de commencer vos interventions.
            </p>
            <Link to="/pointage" className="btn btn-sm btn-primary" style={{ marginTop: '0.5rem' }}>
              <Play size={16} />
              Pointer maintenant
            </Link>
          </div>
        </div>
      )}

      {/* Intervention en cours */}
      {interventionEnCours && (
        <div className="current-intervention-card">
          <div className="current-intervention-header">
            <div className="pulse-indicator"></div>
            <h2>Intervention en cours</h2>
          </div>
          <div className="current-intervention-body">
            <div className="current-intervention-info">
              <div className="current-intervention-plaque">
                {interventionEnCours.plaque}
              </div>
              <div className="current-intervention-type">
                {(() => {
                  const type = getTypeInterventionById(interventionEnCours.typeInterventionId);
                  return type && (
                    <span 
                      className="type-badge" 
                      style={{ backgroundColor: type.couleur }}
                    >
                      {type.code} - {type.libelle}
                    </span>
                  );
                })()}
              </div>
            </div>
            <Link 
              to={`/realisation/${interventionEnCours.id}`}
              className="btn btn-primary btn-lg"
            >
              <Clock size={20} />
              Continuer l'intervention
            </Link>
          </div>
        </div>
      )}

      {/* Liste des interventions à faire */}
      {interventionsPlanifiees.length > 0 && (
        <div className="tech-interventions-list">
          <h2>Interventions à réaliser</h2>
          <div className="interventions-list">
            {interventionsPlanifiees.map(intervention => {
              const type = getTypeInterventionById(intervention.typeInterventionId);
              
              return (
                <Link 
                  key={intervention.id}
                  to={`/realisation/${intervention.id}`}
                  className="intervention-card-mobile"
                >
                  <div className="intervention-header-mobile">
                    <div className="intervention-time-mobile">
                      <Clock size={20} />
                      {intervention.heurePrevu}
                    </div>
                    {type && (
                      <span 
                        className="type-badge" 
                        style={{ backgroundColor: type.couleur }}
                      >
                        {type.code}
                      </span>
                    )}
                  </div>
                  <div className="intervention-body-mobile">
                    <h3 className="intervention-plaque-mobile">{intervention.plaque}</h3>
                    {type && (
                      <p className="text-sm text-muted">
                        Durée estimée: {type.dureeEstimee ? `${type.dureeEstimee} min` : 'Non définie'}
                      </p>
                    )}
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      )}

      {interventionsPlanifiees.length === 0 && interventionsTerminees.length === 0 && !interventionEnCours && (
        <div className="empty-state">
          <CheckCircle size={48} className="icon-muted" />
          <p>Aucune intervention prévue pour aujourd'hui</p>
          <Link to="/realisation" className="btn btn-primary">
            <Plus size={20} />
            Ajouter une intervention
          </Link>
        </div>
      )}
    </div>
  );
}

export default TableauDeBordTechnicien;

